module.exports = __webpack_public_path__ + "img/ma218.042fb0e1.png";